import { errorCodes } from "./constants";
import { Cookies } from "react-cookie";

class Util {
  static cookie = "";

  constructor() {
    this.initcookie();
  }

  initcookie() {
    if (!this.cookie) {
      this.cookie = new Cookies();
    }
  }

  setCookie(cname, cvalue) {
    this.cookie.set(cname, cvalue);
  }

  getCookie(cname) {
    return this.cookie.get(cname);
  }

  convertToFormdata(data) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formData.append(key, data[key]);
      }
    });
    return formData;
  }

  convertDynamicdatatoFields(data) {
    const field = data.map((item) => {
      const fieldMapper = {
        type: "attribute_type",
        name: "code",
        label: "term",
        validation: "is_mandate",
      };
      Object.keys(fieldMapper).map(
        (key) => (fieldMapper[key] = item[fieldMapper[key]])
      );
      return fieldMapper;
    });
    return field;
  }

  convertErrorMessage(message) {
    let errorMessage = "";
    if (typeof message == "object") {
      for (let err of errorCodes) {
        if (message[err?.["title"]]) {
          err?.["indexed"]
            ? (errorMessage = message[err?.["title"]][0])
            : (errorMessage = message[err?.["title"]]);
          break;
        }
      }

      if (errorMessage === "") {
        errorMessage = message[0];
      }
    } else if (message !== "") {
      errorMessage = message;
    }
    return errorMessage;
  }

  setPasswordType = (field, value) => {
    if (value) {
      field[0].type = "text";
    } else {
      field[0].type = "password";
    }
    return field;
  };

  getCoconutDetials = (url) => {
    let queryString = new URLSearchParams(url);
    const parameters = [
      "gst_session",
      "business_id",
      "gst_permission",
      "advisor",
    ];
    let result = {};
    parameters.forEach((param) => {
      result[param] = queryString.get(param) || "";
    });
    return result;
  };

  identifyEnvironment(url) {
    /*for coconut user dev and UAT redirect issues*/
    try {
      const hostname = new URL(url).hostname;
      if (hostname.includes("dev")) {
        return "dev";
      } else if (hostname.includes("uat")) {
        return "uat";
      } else {
        return "live";
      }
    } catch (error) {
      console.error("Error parsing URL:", error.message);
      return "unknown";
    }
  }
}

export const UtilService = new Util();
